export default __webpack_public_path__ + "static/media/mobangels2.4356f8a9.jpg";